import { NavSubItem } from '../../models/nav-sub-item';

export class ProductGroupsNavSubItem extends NavSubItem {}
